<template>
  <div class="header">
    <h1>信箱列表編輯</h1>
  </div>
  <div class="col-12 pt-4" style="min-height: 100px;">
    <el-tag
      v-for="(tag, index) in mailList"
      :key="index"
      class="mx-1 my-1"
      closable
      size="large"
      color="#177baf"
      effect="dark"
      :hit="false"
      @close="handleClose(tag)"
    >
      {{ tag }}
    </el-tag>
  </div>
  <div class="col-8 d-flex align-items-center justify-content-between" style="padding: 50px 0">
    <span class="text-nowrap col-2 text-center">新增電子信箱</span>
    <div class="col-7 d-flex align-items-center position-relative">
      <input
        v-model="addMail"
        class="rounded-pill border info"
        placeholder="請輸入電子信箱地址"
      />
    </div>
    <div class="col-3 d-flex justify-content-start align-items-center px-4">
      <button class="btn btn-outline-primary" @click="pushEmail">新增</button>
    </div>
  </div>
  <div class="col-12 d-flex align-items-center justify-content-center">
    <button
      @click="submit"
      class="btn btn-outline-primary user-btn rounded-pill col-3 ms-2"
    >
      保存
    </button>
  </div>
  <MsgBox
    :show="showMsgBox"
    :errorCode="errorCode"
    :errorMsg="errorMsg"
    @close="showMsgBox = false"
  />
</template>
<script>
import { ref } from '@vue/reactivity'
import MsgBox from '@/components/MsgBox.vue'
import useInfo from '@/composables/useInfo'
import { manualToggleLoading } from '@/plugins/LoadingSpinner'
import MessageBox from '@/plugins/MessageBox'
import { useRouter } from 'vue-router'

export default {
  components: {
    MsgBox,
  },
  setup() {
    const { getEmailList, setEmailList } =
    useInfo()
    const showMsgBox = ref(false)
    const errorMsg = ref('')
    const errorCode = ref('')
    const mailList = ref([])
    const addMail = ref('')
    const router = useRouter()
    const getList = async () => {
      manualToggleLoading(true)
      const res = await getEmailList()
      if (res.error) {
        manualToggleLoading(false)
        showMsgBox.value = true
        errorMsg.value = res.msg
        errorCode.value = res.error
      } else {
        manualToggleLoading(false)
        mailList.value = res.ret.data[0].value.split(',')
      }
    }
    getList()
    const handleClose = (tag)=>{
      const index = mailList.value.findIndex(e=>e === tag)
      mailList.value.splice(index, 1)
    }
    const pushEmail = ()=>{
      const has = mailList.value.find(e=>e === addMail.value)
      if(has){
        showMsgBox.value = true
        errorMsg.value = '信箱已存在'
      }else{
        mailList.value.push(addMail.value)
        addMail.value = ''
      }
    }
    const submit = async () => {
      const res = await setEmailList({
        email: mailList.value.join(',')
      })
      if (res.error) {
        manualToggleLoading(false)
        showMsgBox.value = true
        errorMsg.value = res.msg
        errorCode.value = res.error
      } else {
        manualToggleLoading(false)
        MessageBox({
        message: '編輯成功',
        showCancelButton: false,
        onConfirm: async () => {
          router.push('/user-management/email-list')
        },
      })
      }
      manualToggleLoading(false)
    }
    return {
      errorCode,
      submit,
      showMsgBox,
      errorMsg,
      getList,
      mailList,
      handleClose,
      addMail,
      pushEmail
    }
  },
}
</script>
<style lang="scss" scoped>
.header {
  padding: 40px 0px;
}
h1 {
  font-family: 'Noto Sans';
  font-style: normal;
  font-weight: 700;
  font-size: 24px;
  line-height: 33px;
  color: #000000;
}
.user-img {
  width: 160px;
  height: 160px;
  border: 1px #eff0f6 solid;
  border-radius: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 64px auto 16px;
}
.info {
  width: 100%;
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding: 0 60px 0 32px;
  outline-color: #d1e5ef;
  color: #4d4d4d;
}
.state {
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding: 0 60px 0 32px;
  outline-color: #d1e5ef;
  color: #4d4d4d;
}
input::placeholder {
  font-size: 16px;
}
select {
  background: url('~@/assets/icons/arrow-down.svg') no-repeat scroll 97% center
    transparent;
  appearance: none;
  color: #4d4d4d;
}

.copy {
  right: 32px;
}

.user-btn {
  height: 48px;
  margin: 24px 0 72px 0;
}
.show-password {
  right: 32px;
  position: absolute;
  cursor: pointer;
}
.options {
  display: flex;
  align-items: center;
  width: 120px;
  color: #4d4d4d;
  font-size: 14px;
  margin: 5px 0;
}
.radio {
  width: 20px;
  height: 20px;
  margin-right: 10px;
  border-radius: 999px;
  border: 1px solid #cccccc;
  padding: 4px;
  cursor: pointer;
}
.active {
  color: #177baf;
}
.radio-active {
  border: 1px solid #177baf;
  div {
    width: 100%;
    height: 100%;
    border-radius: 999px;
    background: #177baf;
  }
}
</style>
